import { Tokens } from "@accurx/design";

export const TokenOverrides = {
    ...Tokens,
    BORDERS: {
        ...Tokens.BORDERS,
        radius: "8px",
    },
};
